
import { ObjectField } from "react3l-decorators";
import nameof from "ts-nameof.macro";
import { Project } from "./Project";

import { Organization } from "models/Organization";

ObjectField(Organization)(
  Project.prototype,
  nameof(Project.prototype.organization)
);

export * from "./Project";
export * from "./ProjectFilter";
